import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { PRODUCTS } from '../data/products';
import { useCartStore } from '../store/useCartStore';
export function ProductPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const product = PRODUCTS.find(p => p.id === Number(id));
  const {
    addItem
  } = useCartStore();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!product) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-id="element-232" data-mp="ypbb2ebvcji">
        <div className="text-center" data-id="element-233" data-mp="exypxxmvxyld">
          <h1 className="text-3xl font-serif font-normal text-brand-primary mb-4" data-id="element-234" data-mp="9xapymgoi7f0">
            Товар не знайдено
          </h1>
          <button onClick={() => navigate('/')} className="text-brand-primary text-sm uppercase tracking-[0.15em] font-medium hover:text-brand-accent transition-colors duration-200" data-id="element-235" data-mp="1qarekzkdq6x7">
            Повернутися на головну
          </button>
        </div>
      </div>;
  }
  const features = [{
    title: 'Повністю магнітна основа',
    desc: 'Надійно тримається на холодильнику, не сповзає.'
  }, {
    title: 'Маркер з губкою в комплекті',
    desc: 'Легко пише та стирається без слідів.'
  }, {
    title: 'Багаторазове використання',
    desc: 'Пишіть, стирайте та плануйте знову і знову.'
  }];
  return <div className="min-h-screen bg-brand-bg text-brand-text selection:bg-brand-primary selection:text-brand-bg font-sans pt-32" data-id="element-236" data-mp="xyzmtsz92nmq">
      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-24" data-id="element-237" data-mp="12xkev54cm103">
        <Link to="/" className="inline-flex items-center gap-3 text-brand-muted hover:text-brand-primary font-medium mb-16 transition-colors duration-300 text-[10px] tracking-[0.3em] uppercase" data-id="element-238" data-mp="17pklthiu5u66">
          <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} data-id="element-239" data-mp="f7q5wyn5gwl4" />
          Назад до колекції
        </Link>

        <div className="flex flex-col lg:flex-row gap-16 lg:gap-32" data-id="element-240" data-mp="76r2dkcakvsi">
          {/* Мобільний заголовок та бейдж */}
          <div className="lg:hidden flex flex-col items-center text-center gap-6 mb-8" data-id="element-241" data-mp="368cvwxvg1th">
            <div className="inline-flex items-center gap-3" data-id="element-242" data-mp="gxdh7cc6pia5">
              <span className="font-medium text-[10px] uppercase tracking-[0.3em] text-brand-muted" data-id="element-243" data-mp="byabrqsala1n">
                В наявності
              </span>
            </div>
            <h1 className="text-5xl font-serif font-normal text-brand-primary leading-tight tracking-tight" data-id="element-244" data-mp="3kgf10y6kye6j">
              {product.title}
            </h1>
          </div>

          {/* Фото */}
          <div className="w-full lg:w-1/2 flex-shrink-0" data-id="element-245" data-mp="3uaf4kvm7rbd5">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative w-full overflow-hidden bg-brand-surface aspect-[4/5]" data-id="element-246" data-mp="3pcx4luq6c6ha">
              <img src={product.img} alt={product.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-247" data-mp="2mkb4efpjz2e6" />
            </motion.div>
          </div>

          {/* Інформація */}
          <div className="w-full lg:w-1/2 flex flex-col text-center lg:text-left" data-id="element-248" data-mp="2ijhg3l877lkr">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col h-full" data-id="element-249" data-mp="2illitzud2ejg">
              <div className="hidden lg:flex flex-col gap-6 mb-12" data-id="element-250" data-mp="2wi7fj7ihpxca">
                <div className="inline-flex items-center gap-3 w-fit" data-id="element-251" data-mp="31i3ir4jd5kqs">
                  <span className="font-medium text-[10px] uppercase tracking-[0.3em] text-brand-muted" data-id="element-252" data-mp="31g8y7rc07un8">
                    В наявності
                  </span>
                </div>
                <h1 className="text-6xl lg:text-7xl font-serif font-normal text-brand-primary leading-tight tracking-tight" data-id="element-253" data-mp="3tzz18p6ci1s3">
                  {product.title}
                </h1>
              </div>

              <p className="text-xl text-brand-muted mb-16 leading-relaxed font-light" data-id="element-254" data-mp="20cff7rk81q3p">
                {product.fullDesc}
              </p>

              <div className="mb-16 text-left" data-id="element-255" data-mp="1rdbu6i1hv0mk">
                <h3 className="font-serif font-normal text-brand-primary text-2xl mb-8 text-center lg:text-left" data-id="element-256" data-mp="1remyciyuqae7">
                  Що ви отримуєте:
                </h3>
                <div className="space-y-8" data-id="element-257" data-mp="2k1hiferrb7r5">
                  {features.map((item, idx) => <div key={idx} className="flex gap-8" data-id="element-258" data-mp="2fa7qg7iqjsc3" data-mpi={idx}>
                      <span className="text-xs font-medium text-brand-muted tabular-nums pt-1 w-6 flex-shrink-0 tracking-widest" data-id="element-259" data-mp="2abepfekmxtst">
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      <div data-id="element-260" data-mp="32yim8w9kr1ti">
                        <span className="font-serif font-normal text-brand-primary block text-xl mb-2" data-id="element-261" data-mp="3abzzdbqh3l55">
                          {item.title}
                        </span>
                        <span className="text-brand-muted text-base leading-relaxed font-light" data-id="element-262" data-mp="3fcxh5n7kmd64">
                          {item.desc}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>

              <div className="mt-auto pt-8 flex flex-col sm:flex-row items-center sm:items-end justify-between gap-10 border-t border-brand-primary/10" data-id="element-263" data-mp="3ta2tg4xvo89t">
                <div className="text-center sm:text-left w-full sm:w-auto" data-id="element-264" data-mp="6uhsb6iiyi5s">
                  <p className="text-[10px] text-brand-muted font-medium uppercase tracking-[0.3em] mb-4" data-id="element-265" data-mp="6xdtr4tkzoyz">
                    Інвестиція в спокій
                  </p>
                  <div className="text-5xl font-serif font-normal text-brand-primary" data-id="element-266" data-mp="fxai15c26lti">
                    {product.price}{' '}
                    <span className="text-xl font-sans font-light text-brand-muted" data-id="element-267" data-mp="ksg88gchumne">грн</span>
                  </div>
                </div>
                <button onClick={() => addItem(product)} className="w-full sm:w-auto px-12 py-5 bg-brand-primary hover:bg-brand-primaryHover text-white text-xs uppercase tracking-[0.2em] font-medium transition-colors duration-300 flex items-center justify-center gap-4 group" data-id="element-268" data-mp="2cx52iz9t6e6a">
                  Замовити зараз
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" data-id="element-269" data-mp="2vmtt6g6mn8fu" />
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-brand-primary text-brand-bg py-24 mt-32" data-id="element-270" data-mp="34okyhjx99d96">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-10" data-id="element-271" data-mp="1f8bnnhz8bs80">
          <div className="text-3xl font-serif font-normal tracking-tight" data-id="element-272" data-mp="1aaa9nbgnuj3e">
            MyPlaner<span className="text-brand-accent" data-id="element-273" data-mp="3lwc2tdrd0oty">.</span>
          </div>
          <div className="text-brand-bg/40 text-xs font-light tracking-wide" data-id="element-274" data-mp="3lz6o17i76dof">
            © {new Date().getFullYear()} MyPlaner. Всі права захищені.
          </div>
        </div>
      </footer>
    </div>;
}